import { getGoogleAnalyticsURL } from 'analytics/sendGoogleAnalyticsEvent';

export const useTrolleyAnalytics = () => {
  const trackAbandonTrolleyUpdateEvent = (
    pageLocation: string | null,
    clientId: string | null,
    sessionId: string | null,
    customerId: string,
    orderId: string,
  ) => {
    if (__SERVER__) return;

    navigator.sendBeacon(
      getGoogleAnalyticsURL(),
      JSON.stringify({
        client_id: clientId,
        events: [
          {
            params: {
              event_name: 'abandoned_trolley_update',
              session_id: sessionId,
              page_location: pageLocation,
              user_id: customerId,
              customer_id: customerId,
              order_id: orderId,
            },
          },
        ],
      }),
    );
  };

  return {
    trackAbandonTrolleyUpdateEvent,
  };
};
